module.exports = __webpack_public_path__ + "static/media/2.840f350f.jpg";